import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function getMultiplexList() {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.getMultiplex
  }).then(r => r.data);
}

export default {
  getMultiplexList
};



// WEBPACK FOOTER //
// ./src/repositories/multiplex.repository.js